import { useQuery } from "@tanstack/react-query"
import { getFacebookPages } from "../services/social-publish.service"

export function useFacebookPages(enabled = true) {
  return useQuery({
    queryKey: ["facebook-pages"],
    queryFn: getFacebookPages,
    enabled,
    staleTime: 60_000, // 1 minute
  })
}
